import type { Endpoint } from ".";

// Path stays `/projects` (plural — REST collection convention). The single
// "get project by id" endpoint was dropped because each partner is scoped
// to one (or a small handful of) projects; the collection response IS the
// partner's project list.
export const getProjects: Endpoint = {
  id: "getProjects",
  method: "GET",
  path: "/projects",
  summary: "Get projects",
  description:
    "Returns the project(s) visible to the authenticated caller. Excludes the pseudo-project named \"Unassigned\". Sorted by name ascending.",
  params: [],
};
